import { Pipe, PipeTransform } from '@angular/core';
import { statusTranslationSubtitles } from './../config/config/config.constants';

@Pipe({
  name: 'greatingTranslation'
})
/**
 * Used to display the subtitle
 * depends on the status translation of an OrderStatus
 * Order.orderStatus -> GreatingTranslationPipe
 */
export class GreatingTranslationPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    value = value.replace(/<[^>]+>/g, '');
    const subtitles = statusTranslationSubtitles;
    return subtitles[value] ? subtitles[value]
      : 'Welcome to SimpleDose&trade; presorted Rx packs.';
  }

}
